import React, { createContext, useContext, useEffect, useState } from "react";
import config from "../service/config";

const AllDivisionContext = createContext([]);

export const ApiProvider = ({ children }) => {
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [role, setRole] = useState(localStorage.getItem("role"));
  const [loggedBy, setLoggedBy] = useState(
    localStorage.getItem("loggedBy") || ""
  );
  const [clientCompany, setClientCompany] = useState(
    localStorage.getItem("client_company_name")
  );
  const [userMail, setUserMail] = useState(
    localStorage.getItem("userMail") || ""
  );
  const [clientId, setClientId] = useState(
    localStorage.getItem("clientId") || ""
  );
  const [userId, setUserId] = useState(localStorage.getItem("user_id") || "");
  const [filterEscrowVal, setFilterEscrowVal] = useState([]);
  const [filterCompanyName, setFilterCompanyName] = useState([]);
  const [selectedEscrowName, setSelectedEscrowName] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // New loading state
  const [escrowEntries, setEscrowEntries] = useState([]);

  /* Company Dropdown */
  const [companyDropdown, setCompanyDropDown] = useState([]);
  const [transactionData, setTransactionData] = useState([]);
  const [collectsEnabled, setCollectsEnabled] = useState(false);
  const [payoutsEnabled, setPayoutsEnabled] = useState(false);
  const [escrowList, setEscrowList] = useState([]);
  const [refreshData, setRefreshData] = useState(false);
  const [subescrowSidebar, setSubescrowSidebar] = useState(false);
  const [makerLimit, setMakerLimit] = useState(
    localStorage.getItem("makerLimit") || ""
  );
  const [approverLimit, setApproverLimit] = useState(
    localStorage.getItem("approverLimit") || ""
  );
  const [comp_name, setComp_name] = useState("");

  useEffect(() => {
    const companyName = localStorage.getItem("company_name") || "";
    const escrowName = localStorage.getItem("escrow_name") || "";
    setSelectedCompanyName(companyName);
    setSelectedEscrowName(escrowName);
  }, []);

  useEffect(() => {
    if (!clientId) return;
    console.log("client----->", clientCompany);
    setLoading(true);
    const url =
      clientCompany !== "undefined" && loggedBy === "client"
        ? `${
            config.node_api_endpoint
          }/api/escrow-details?client_id=${clientId}&company_name=${encodeURIComponent(
            clientCompany
          )}`
        : `${config.node_api_endpoint}/api/escrow-details?client_id=${clientId}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch escrow details");
        }
        return res.json();
      })
      .then((result) => {
        setLoading(false);
        setRefreshData(false);
        console.log("entries-->", result);
        const entries = result?.data?.entries;

        if (result.success && Array.isArray(entries)) {
          setEscrowEntries(entries);

          const companies = entries.map((e) => e.company_name);
          setCompanyDropDown(companies);

          if (companies.length > 0) {
            const firstCompany = companies[0];

            setSelectedCompanyName(firstCompany);
            localStorage.setItem("company_name", firstCompany); // ✅ Use global localStorage

            const matchedEntry = entries.find(
              (e) => e.company_name === firstCompany
            );

            const subEscrows = matchedEntry?.sub_escrow?.map((s) => s.id) || [];

            setFilterEscrowVal(subEscrows);
            if (subEscrows.length > 0) {
              setSelectedEscrowName(subEscrows[0]);
              window.localStorage.setItem("escrow_name", subEscrows[0]); // ✅ Save first escrow
            }
          } else {
            setFilterEscrowVal([]);
          }
        } else {
          setCompanyDropDown([]);
          setFilterEscrowVal([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching escrow details:", error);
        setCompanyDropDown([]);
        setFilterEscrowVal([]);
      });
  }, [clientId, clientCompany, makerLimit, approverLimit, refreshData]);

  useEffect(() => {
    if (!clientId) return;
    setLoading(true);
    const url =
      clientCompany !== "undefined" && loggedBy === "client"
        ? `${
            config.node_api_endpoint
          }/api/add-escrow?client_id=${clientId}&registered_company_name=${encodeURIComponent(
            clientCompany
          )}`
        : `${config.node_api_endpoint}/api/add-escrow?client_id=${clientId}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
    })
      .then((res) => {
        console.log("res-->", res);
        if (!res.ok) {
          throw new Error("Failed to fetch escrows");
        }
        return res.json();
      })
      .then((result) => {
        setLoading(false);
        setRefreshData(false);
        console.log("escroData-->", result.data);
        if (result.success && Array.isArray(result.data)) {
          setEscrowList(result?.data);
          const filterWhiteListing = result.data.filter(
            (data) => data.registered_company_name === selectedCompanyName
          );

          setCollectsEnabled(filterWhiteListing[0]?.collects_enabled);
          setPayoutsEnabled(filterWhiteListing[0]?.payouts_enabled);
        } else {
          setEscrowList(result?.data);
          setCollectsEnabled(result?.data?.collects_enabled);
          setPayoutsEnabled(result?.data?.payouts_enabled);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching escrows:", error);
        setEscrowList([]);
      });
  }, [clientId, selectedCompanyName, refreshData, clientCompany, loggedBy]);

  useEffect(() => {
    if (!clientId || !clientCompany) return;
    setLoading(true);
    fetch(
      `${
        config.node_api_endpoint
      }/api/escrow-subescrow-toggle?client_id=${clientId}&company_name=${encodeURIComponent(
        clientCompany
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY, // ✅ your API key here
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setLoading(false);
          setSubescrowSidebar(result.isSubEscrowAllowed);
        } else {
          setLoading(false);
          console.error("Failed to fetch toggle value:", result.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("API error:", err);
      });
  }, [clientId, clientCompany, refreshData]);

  const fetchEscrowEntries = () => {
    if (!clientId) return;

    setLoading(true); // ✅ Start loading

    const url =
      clientCompany !== "undefined" && loggedBy === "client"
        ? `${
            config.node_api_endpoint
          }/api/escrow-details?client_id=${clientId}&company_name=${encodeURIComponent(
            clientCompany
          )}`
        : `${config.node_api_endpoint}/api/escrow-details?client_id=${clientId}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "test_1234567890abcdef",
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch escrow details");
        }
        return res.json();
      })
      .then((result) => {
        if (result.success && Array.isArray(result?.data?.entries)) {
          setEscrowEntries(result.data.entries);
        } else {
          setEscrowEntries([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching escrow entries:", error);
        setEscrowEntries([]);
      })
      .finally(() => {
        setLoading(false); // ✅ Stop loading in finally block
      });
  };

  console.log("escrowList-->", escrowList);
  return (
    <AllDivisionContext.Provider
      value={{
        setSelectedCompanyName,
        setFilterEscrowVal,
        filterEscrowVal,
        selectedCompanyName,
        filterCompanyName,
        dataSource,
        setDataSource,
        selectedEscrowName,
        setSelectedEscrowName,
        companyDropdown,
        transactionData,
        loading, // Provide loading state to context
        setLoading,
        role,
        setRole,
        clientId,
        setClientId,
        setUserMail,
        userMail,
        escrowEntries,
        loggedBy,
        setLoggedBy,
        collectsEnabled,
        payoutsEnabled,
        escrowList,
        setRefreshData,
        refreshData,
        clientCompany,
        setClientCompany,
        setMakerLimit,
        makerLimit,
        approverLimit,
        setApproverLimit,
        comp_name,
        setComp_name,
        subescrowSidebar,
        setSubescrowSidebar,
        fetchEscrowEntries,
        userId,
        setUserId,
      }}
    >
      {children}
    </AllDivisionContext.Provider>
  );
};

export const useAllProduct = () => {
  const context = useContext(AllDivisionContext);

  if (context === null) {
    throw new Error("useAllProduct must be used within a AllProductProvider");
  }
  if (!context) {
    throw new Error("useAllProduct must be used within a ApiProvider");
  }

  return context;
};

export default AllDivisionContext;
